import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=39aa006e&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=39aa006e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa006e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39aa006e')) {
      api.createRecord('39aa006e', component.options)
    } else {
      api.reload('39aa006e', component.options)
    }
    module.hot.accept("./app-header.vue?vue&type=template&id=39aa006e&scoped=true&", function () {
      api.rerender('39aa006e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-header/app-header.vue"
export default component.exports